/**
 * Structured Data (JSON-LD) Utilities
 *
 * Schema.org structured data for SEO and rich results.
 */

import { SEO_CONFIG } from './config';

/**
 * Organization schema for Saqr Skills
 */
export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Saqr Skills',
    url: SEO_CONFIG.baseUrl,
    logo: `${SEO_CONFIG.baseUrl}/og-default.png`,
    description:
      'AI-powered voice assessment platform for corporate training and L&D teams.',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@saqracademy.com',
      contactType: 'sales',
      availableLanguage: ['English', 'Arabic'],
    },
    sameAs: ['https://www.linkedin.com/company/saqr-academy'],
  };
}

/**
 * SoftwareApplication schema for Saqr Skills platform
 */
export function getSoftwareApplicationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: 'Saqr Skills',
    applicationCategory: 'BusinessApplication',
    operatingSystem: 'Web',
    description:
      'AI-powered voice assessment platform that measures real capability change through live voice conversations. Design assessments in minutes, score automatically, get defensible results.',
    url: SEO_CONFIG.baseUrl,
    offers: {
      '@type': 'Offer',
      price: '0',
      priceCurrency: 'USD',
      description: 'Contact for enterprise pricing',
    },
    featureList: [
      'AI-generated assessment authoring',
      'Live voice assessments with AI personas',
      'Automated scoring with evidence citations',
      'Written assessments (MCQ, SJT)',
      'Enterprise webhook integration',
      'Bilingual support (English, Arabic)',
    ],
    audience: {
      '@type': 'BusinessAudience',
      audienceType: 'Corporate L&D teams, Training consultants, HR departments',
    },
  };
}

/**
 * BreadcrumbList schema
 */
export function getBreadcrumbSchema(
  items: Array<{ name: string; path: string }>
) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: `${SEO_CONFIG.baseUrl}${item.path}`,
    })),
  };
}

/**
 * Serialize structured data for injection into page
 */
export function serializeSchema(schema: object | object[]): string {
  return JSON.stringify(schema);
}
